import { EditorActor } from "../requestEditor";

export class BuilderSendGroupModel {
    sendGroupGuid!: string;
    name!: string;
    sendDate!: Date;
    deadline!: Date;
    deadlineDays: number = 0;
    order!: number;
    actions!: EditorActor[];
}

export class BuilderUpdateSendGroupDeadlineDaysModel {
    sendGroupGuid!: string;
    deadlineDays!: number;

}

export class BuilderUpdateSendGroupDeadlineModel {
    sendGroupGuid!: string;
    deadline!: Date;

}

export class BuilderUpdateSendGroupModel {
    sendGroupGuid!: string;
    sendGroupName!: string
    deadline?: Date | null;
    deadlineDays?: number | null;
}

export class BuilderUpdateSendGroupNameModel {
    sendGroupGuid!: string;
    sendGroupName!: string
}
